import { combineReducers } from "redux";
import parties from "../features/webisite/parties/slice";
import invoices from "../features/webisite/invoice/slice";
import vendors from "../features/webisite/vendor/slice";
import products from "../features/webisite/product/slice";
import expenses from "../features/webisite/expense/slice";
import auth from "../features/webisite/auth/slice";
import reports from "../features/webisite/report/slice";
import wallet from "../features/webisite/wallet/slice";
import subscription from "../features/webisite/subcription/slice";


const WebMasters = combineReducers({
    parties,
    invoices,
    vendors,
    products,
    expenses,
    auth,
    reports,
    wallet,
    subscription,
});

export default WebMasters;
